export function formatBigNumber(value) {
  if (value === null || value === undefined || isNaN(value)) return "0";

  if (value >= 1_000_000) {
    return (value / 1_000_000).toFixed(2).replace(/\.00$/, "") + "M";
  } else if (value >= 1_000) {
    return (value / 1_000).toFixed(2).replace(/\.00$/, "") + "K";
  } else {
    return value.toString();
  }
}
